import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import AuthApp from './components/AuthApp';
import ErrorBoundary from './components/ErrorBoundary';
import {
  initTelemetry,
  installBootstrapHandlers,
  logger,
} from './lib/telemetry';
import { getSiteSettings } from './providers/authService';

// Buffer any error thrown before telemetry is ready. Uninstalled by initTelemetry.
installBootstrapHandlers();

// Fast path: setSiteSettings persists the settings blob, so on every visit after the first
// telemetry is live before React renders -- which is when bootstrap failures happen. No-ops on
// a first-ever visit, and AuthApp calls initTelemetry again once /settings responds.
try {
  initTelemetry(getSiteSettings());
} catch {
  // getSiteSettings parses localStorage; a corrupt blob must not stop the app booting.
}

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  // Inside the router so the boundary's ErrorView, which uses useNavigate, has a router
  // context. Nothing covered the root render before this.
  <BrowserRouter basename={baseUrl}>
    <ErrorBoundary name="Root">
      <AuthApp />
    </ErrorBoundary>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// Core Web Vitals as custom metrics. `rating` is web-vitals' own good /
// needs-improvement / poor bucket, which gives free segmentation. CLS is a unitless score
// while the rest are milliseconds, so the unit travels as a dimension rather than being
// rescaled -- rescaling would make the number lie in a dashboard.
reportWebVitals(({ name, value, id, rating }) =>
  logger.metric(`WebVitals.${name}`, value, {
    Rating: rating,
    MetricId: id,
    Unit: name === 'CLS' ? 'score' : 'ms',
    Operation: 'WebVitals',
  })
);
